import { useClerk } from "@clerk/clerk-react";

export const LoginButton = () => {
  const { redirectToSignIn } = useClerk();
  return (
    <button
      onClick={() => redirectToSignIn()}
      className="px-4 py-2 bg-primary text-primary-foreground font-medium rounded-full hover:bg-primary/90 transition-colors"
    >
      Log in
    </button>
  );
}
